
import { NewsLetterError } from '@/exceptions/news_letter/news.enum';
import { newsLetterService } from '@/services/news_letter.service';
import { notificationService } from '@/services/notification.service';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useDeleteNewsLetter = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (newsLetterId: number) =>
			await newsLetterService.deleteNewsLetter(newsLetterId),

		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['newsLetter'] });
			notificationService.success("NewsLetter deleted Succesful");

		},

		onError: () => {
			throw new Error(NewsLetterError.DELETE_ERROR);
		},
	});
};

export default useDeleteNewsLetter;